export default {
  '锻炼记录列表':'锻炼记录列表',
  '视频不存在':'视频不存在',
}